import { render, staticRenderFns } from "./PointDetails.vue?vue&type=template&id=4ca30381"
import script from "./PointDetails.vue?vue&type=script&lang=js"
export * from "./PointDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports